// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3SvUg","disabled":"FileBtn_disabled__X1Kts","warn":"FileBtn_warn__1QWLe","fade":"FileBtn_fade__246AX"};